import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { BreakpointService } from '@libs/index';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { StateService } from '../../../services/state/state.service';
import { BaseComponent } from '@libs/index';
import { takeUntil } from 'rxjs/operators';
import { User } from '@libs/index';
import { GtmService } from '../../../services/gtm/gtm.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends BaseComponent implements OnInit {
  @Input() user: User;
  @Input() menuOpened: boolean;
  @Input() isHeaderTransparent: boolean;
  @Input() isDarkMode: boolean;

  @Output() toggleSideNav = new EventEmitter<any>();

  public showBackground = false;

  constructor(
    public breakpointService: BreakpointService,
    private changeDetector: ChangeDetectorRef,
    private stateService: StateService,
    private gtmService: GtmService,
    private navigationService: NavigationService
  ) {
    super();
  }

  ngOnInit() {
    this.stateService.scrollPosition$
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((value) => {
        const newValue = !!value && value > 0;
        if (newValue !== this.showBackground) {
          this.showBackground = newValue;
          this.changeDetector.detectChanges();
        }
      });
  }

  public async navigateToHome() {
    if (this.menuOpened) {
      this.toggleSideNav.emit();
    }

    await this.gtmService.emitBranchLogoClickEvent(window.location.pathname);
    await this.navigationService.navigateToHome();
  }
}
